// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PromoAdmin_card__oQ0IU {
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 16px;
}

.PromoAdmin_header__1mCU3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.PromoAdmin_btn__m0NtD {
  background: #0d263f;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
}

.PromoAdmin_btn__m0NtD.PromoAdmin_red__XDzLR {
  background: #e72f44;
}

.PromoAdmin_btn__m0NtD.PromoAdmin_ghost__p4uaq {
  background: transparent;
  color: #0d263f;
  border: 1px solid #0d263f;
}

.PromoAdmin_btn__m0NtD.PromoAdmin_small__bI-9c {
  padding: 6px 10px;
  font-size: 14px;
}

.PromoAdmin_table__O3Hg7 {
  width: 100%;
  border-collapse: collapse;
}

.PromoAdmin_table__O3Hg7 th, .PromoAdmin_table__O3Hg7 td {
  border-top: 1px solid #eee;
  padding: 10px;
  text-align: left;
  vertical-align: middle;
}

.PromoAdmin_badge__xpP7B {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 12px;
}

.PromoAdmin_input__fWSN- {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
}

.PromoAdmin_row__PnUCQ {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.PromoAdmin_col__n6QYE {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.PromoAdmin_preview__m5\\+XV {
  width: 160px;
  height: 90px;
  background: #f5f5f5;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
}

.PromoAdmin_toolbar__h8goE {
  display: flex;
  gap: 8px;
  align-items: center;
}

.PromoAdmin_dragHint__\\+GB-S {
  font-size: 12px;
  opacity: 0.6;
}

.PromoAdmin_handle__bLL9T {
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/admin/promo/PromoAdmin.module.scss"],"names":[],"mappings":"AAAA;EAAQ,gBAAA;EAAiB,yBAAA;EAA0B,mBAAA;EAAoB,aAAA;AAKvE;;AAJA;EAAU,aAAA;EAAc,mBAAA;EAAoB,8BAAA;EAA+B,mBAAA;AAW3E;;AAVA;EAAO,mBAAA;EAAoB,WAAA;EAAY,YAAA;EAAa,kBAAA;EAAmB,iBAAA;EAAkB,eAAA;AAmBzF;;AAlBA;EAAW,mBAAA;AAsBX;;AArBA;EAAa,uBAAA;EAAwB,cAAA;EAAe,yBAAA;AA2BpD;;AA1BA;EAAa,iBAAA;EAAkB,eAAA;AA+B/B;;AA9BA;EAAS,WAAA;EAAY,yBAAA;AAmCrB;;AAlCA;EAAuB,0BAAA;EAA2B,aAAA;EAAc,gBAAA;EAAiB,sBAAA;AAyCjF;;AAxCA;EAAS,mBAAA;EAAoB,yBAAA;EAA0B,oBAAA;EAAqB,gBAAA;EAAiB,eAAA;AAgD7F;;AA/CA;EAAS,WAAA;EAAY,iBAAA;EAAkB,yBAAA;EAA0B,kBAAA;AAsDjE;;AArDA;EAAO,aAAA;EAAc,8BAAA;EAA+B,SAAA;AA2DpD;;AA1DA;EAAO,aAAA;EAAc,sBAAA;EAAuB,QAAA;AAgE5C;;AA/DA;EAAW,YAAA;EAAa,YAAA;EAAa,mBAAA;EAAoB,0BAAA;EAA2B,kBAAA;EAAmB,sBAAA;EAAuB,2BAAA;AAyE9H;;AAxEA;EAAW,aAAA;EAAc,QAAA;EAAS,mBAAA;AA8ElC;;AA7EA;EAAY,eAAA;EAAgB,YAAA;AAkF5B;;AAjFA;EAAU,YAAA;EAAa,yBAAA;UAAA,iBAAA;AAsFvB","sourcesContent":[".card { background:#fff; border:1px solid #e6e6e6; border-radius:10px; padding:16px; }\r\n.header { display:flex; align-items:center; justify-content:space-between; margin-bottom:12px; }\r\n.btn { background:#0d263f; color:#fff; border:none; border-radius:8px; padding:8px 12px; cursor:pointer; }\r\n.btn.red { background:#e72f44; }\r\n.btn.ghost { background:transparent; color:#0d263f; border:1px solid #0d263f; }\r\n.btn.small { padding:6px 10px; font-size:14px; }\r\n.table { width:100%; border-collapse:collapse; }\r\n.table th, .table td { border-top:1px solid #eee; padding:10px; text-align:left; vertical-align:middle; }\r\n.badge { background:#f1f5f9; border:1px solid #e2e8f0; border-radius:999px; padding:2px 8px; font-size:12px; }\r\n.input { width:100%; padding:8px 10px; border:1px solid #d1d5db; border-radius:8px; }\r\n.row { display:grid; grid-template-columns:1fr 1fr; gap:12px; }\r\n.col { display:flex; flex-direction:column; gap:6px; }\r\n.preview { width:160px; height:90px; background:#f5f5f5; border:1px dashed #d1d5db; border-radius:8px; background-size:cover; background-position:center; }\r\n.toolbar { display:flex; gap:8px; align-items:center; }\r\n.dragHint { font-size:12px; opacity:.6; }\r\n.handle { cursor:grab; user-select:none; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `PromoAdmin_card__oQ0IU`,
	"header": `PromoAdmin_header__1mCU3`,
	"btn": `PromoAdmin_btn__m0NtD`,
	"red": `PromoAdmin_red__XDzLR`,
	"ghost": `PromoAdmin_ghost__p4uaq`,
	"small": `PromoAdmin_small__bI-9c`,
	"table": `PromoAdmin_table__O3Hg7`,
	"badge": `PromoAdmin_badge__xpP7B`,
	"input": `PromoAdmin_input__fWSN-`,
	"row": `PromoAdmin_row__PnUCQ`,
	"col": `PromoAdmin_col__n6QYE`,
	"preview": `PromoAdmin_preview__m5+XV`,
	"toolbar": `PromoAdmin_toolbar__h8goE`,
	"dragHint": `PromoAdmin_dragHint__+GB-S`,
	"handle": `PromoAdmin_handle__bLL9T`
};
export default ___CSS_LOADER_EXPORT___;
